export default __webpack_public_path__ + "static/media/Plugin.ab63b1f0.svg";